import { Config, IState } from '@/types';
import _ from 'lodash';
import Vue from 'vue';
import Vuelidate from 'vuelidate';
import VueAnalytics from 'vue-analytics';
import VueTippy from 'vue-tippy';
import 'iframe-resizer/js/iframeResizer.contentWindow.js';

import App from './App.vue';
import storeFactory from './store/';
import './filters';
import './components';

(async (client: string = 'lifetime') => {
  // Yeah this is weird syntax but it allows you to get the client config dynamically
  const config: Config = (await import(/* webpackMode: "eager" */ `../clients/${client}/`)).default;
  const store = storeFactory(config);

  Vue.config.productionTip = false;

  Vue.use(Vuelidate);
  Vue.use(VueTippy);

  Vue.use(VueAnalytics, {
    id: ['UA-115188430-3', store.state.ui.ga],
    autoTracking: {
      exception: true,
    },
    set: [{
      field: 'client',
      value: store.state.copy.name,
    }],
  });

  (window as any).App = new Vue({
    store,
    render: (h) => h(App),
    methods: {
      debugState(state: IState) {
        this.$store.replaceState(state);
      },
    },
    created() {
      if (config.hooks && _.isFunction(config.hooks.beforeInitialise)) {
        config.hooks.beforeInitialise(this, this.$store);
      }
    },
    mounted() {
      this.$nextTick(() => {
        if (config.hooks && _.isFunction(config.hooks.afterInitialise)) {
          config.hooks.afterInitialise(this, this.$store);
        }
      });
    },
  }).$mount('#lifetime-contributions');
})(process.env.VUE_APP_CLIENT);
